module.exports = __webpack_public_path__ + "static/media/present.3756ba14.png";